import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import BdsButton from '../../../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import CountUpNumber from '../../../../../../shared/components/v3/CountUpNumber/CountUpNumber';
import { COUNT_UP_DURATION } from '../../../../../../shared/constants/reports';
import { HOW_TO_USE_MEDISMART_LINK } from '../../../../../../shared/constants/requests';
import { CLICK_ACTION, HEALTH_REPORT_INSURANCE_USAGE } from '../../../../../../shared/constants/tagManager';
import useInView from '../../../../../../shared/hooks/useInView/useInView';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import TagManagerService from '../../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';
import { redirectToPage } from '../../../../../../shared/utils/utils';

import './TelemedicineInsight.scss';

export const TelemedicineInsight = ({
  data,
  isLastReport,
  inDownloadMode
}: {
  data: IHealthReport;
  isLastReport?: boolean;
  inDownloadMode?: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ref: containerRef, enterCount: cycle } = useInView<HTMLDivElement>({
    threshold: 0.3,
    enabled: !inDownloadMode
  });

  const openInstructions = () => {
    TagManagerService.pushEvent(CLICK_ACTION, HEALTH_REPORT_INSURANCE_USAGE, { type: 'instructive' });
    redirectToPage(navigate, HOW_TO_USE_MEDISMART_LINK);
  };

  return (
    <div className="telemedicine-insight-container" ref={containerRef}>
      <p className="insight-title">
        <span className="insight-percentage">
          {inDownloadMode ? (
            `${data.telemedicineUsePercentage ?? 0}%`
          ) : (
            <CountUpNumber
              key={`users-approved-${cycle}`}
              value={data.telemedicineUsePercentage ?? 0}
              duration={COUNT_UP_DURATION}
              suffix="%"
            />
          )}
        </span>
        {` ${t(TRANSLATIONS_REPORTS.healthReport.telemedicineData.insight.title)}`}
      </p>
      <p className="health-report-description">
        {t(TRANSLATIONS_REPORTS.healthReport.telemedicineData.insight.description)}
      </p>
      {isLastReport && (
        <div className="only-landing">
          <BdsButton variant="quaternary" size="s" action={openInstructions}>
            {t(TRANSLATIONS_REPORTS.healthReport.telemedicineData.insight.button)}
          </BdsButton>
        </div>
      )}
    </div>
  );
};

export default TelemedicineInsight;
